<template>
	<div name="hres3cu-detail-process-popup" id="hres3cu-detail-process-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="detailPopupProcessModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES3CUC3']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">	
        	<div class="detail detail-responsive">

            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['20'] }}</label>
                <div class="col-md-5">
                  <div class="detail-text width-100" >{{indexSelected.numcom}}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
            <div class="form-group margin-b-5">
               <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['30'] }}</label>
                <div class="col-md-5">
                  <hrms-datepicker  v-model="paramDetailProcess.dteopert"
                                    name="dteopert"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    :has-error="errors.has('dteopert')" />
                  <div class="text-error" v-show="errors.has('dteopert')">{{errors.first('dteopert')}}</div>  
                </div> 
            </div>
            </form>

            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label"> {{ labels['HRES3CUC3']['40'] }}</label>
                <div class="col-md-5">
                  <hrms-lov   v-model="paramDetailProcess.codopert"
                              :nowLang="nowLang"
                              lovType="codempid"
                              v-validate="'required'"
                              data-vv-value-path="inputValue"
                              data-vv-name="codopert"
                              name="codopert"  />
                  <div class="text-error" v-show="errors.has('codopert')">{{errors.first('codopert')}}</div>  
                </div>
              </div>
            </form>

            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['50'] }}</label>
                <div class="col-md-5">
                  <textarea class="form-control" 
                            v-model="paramDetailProcess.desopert"
                            maxlength="200" 
                            v-validate="'required|max:200'"
                            data-vv-name="desopert"
                            :has-error="errors.has('desopert')"></textarea>
                  <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div> 
                  <div class="text-error" v-show="errors.has('desopert')">{{errors.first('desopert')}}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['60'] }}</label>
                <div class="col-md-5">
                  <textarea class="form-control" 
                            v-model="paramDetailProcess.limopert"
                            maxlength="200"
                            v-validate="'max:200'"
                            data-vv-name="limopert"
                            :has-error="errors.has('limopert')" ></textarea>
                  <div class="text-error" v-show="errors.has('limopert')">{{errors.first('limopert')}}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div> 
                </div>
              </div>
            </form>
             <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['70'] }}</label>
                <div class="col-md-5">
                  <textarea class="form-control" 
                            v-model="paramDetailProcess.resopert"
                            maxlength="200"
                            v-validate="'requiredWhenExist:dteres|max:200'"
                            data-vv-name="resopert"
                            name="resopert"
                            :has-error="errors.has('resopert')" ></textarea>
                  <div class="text-error" v-show="errors.has('resopert')">{{errors.first('resopert')}}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div> 
                </div>
              </div>
            </form>
            <form class="form-horizontal">
            <div class="form-group margin-b-5">
               <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['80'] }}</label>
                <div class="col-md-5">
                  <hrms-datepicker  v-model="paramDetailProcess.dteres"
                                    v-validate="'requiredWhenExist:resopert|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="dteres"
                                    :has-error="errors.has('dteres')" />
                  <div class="text-error" v-show="errors.has('dteres')">{{errors.first('dteres')}}</div>  
                </div> 
            </div>
            </form>
            <form class="form-horizontal">
            <div class="form-group margin-b-5">
               <label class="col-md-4 control-label">{{ labels['HRES3CUC3']['90'] }}</label>
                <div class="col-md-5">
                  <input type="hidden" name="currentDate" v-model="currentDate">
                  <hrms-datepicker  v-model="paramDetailProcess.dteclose"
                                    v-validate="'date_format:DD/MM/YYYY|before:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteclose"
                                    :has-error="errors.has('dteclose')" />
                  <div class="text-error">** {{ hres3cuLabels[nowLang]['10'] }} </div>
                  <div class="text-error" v-show="errors.has('dteclose')">{{errors.first('dteclose')}}</div>
                </div> 
            </div>
            </form>
        	</div>			
        </div>

        <div class="modal-footer align-left">
          <button type="button" class="btn bg-dark-gray" @click="closeModal()"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" v-if="validateStaappr"  @click="save()" ><i class="fa fa-check-circle"></i> {{ labelsButton['save'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres3cu-detail-process-popup',
  data () {
    return {
      currentDate: moment().format('DD/MM/YYYY'),
      paramDetailProcess: {
        numcom: this.detailPopupProcess.numcom,
        dteopert: this.detailPopupProcess.dteopert,
        codopert: this.detailPopupProcess.codopert,
        desopert: this.detailPopupProcess.desopert,
        limopert: this.detailPopupProcess.limopert,
        resopert: this.detailPopupProcess.resopert,
        dteres: this.detailPopupProcess.dteres,
        dteclose: this.detailPopupProcess.dteclose
      },
      hres3cuLabels: {
        en: {
          '10': 'Please enter the closing date to close this complaint.'
        },
        th: {
          '10': 'ใส่วันที่ปิด เมื่อต้องการปิดคำร้องเรียนนี้'
        }
      }
    }
  },
  watch: {
    detailPopupProcess () {
      this.paramDetailProcess = {
        numcom: this.detailPopupProcess.numcom,
        dteopert: this.detailPopupProcess.dteopert,
        codopert: this.detailPopupProcess.codopert,
        desopert: this.detailPopupProcess.desopert,
        limopert: this.detailPopupProcess.limopert,
        resopert: this.detailPopupProcess.resopert,
        dteres: this.detailPopupProcess.dteres,
        dteclose: this.detailPopupProcess.dteclose
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    },
    'detailPopupProcess.numcom' () {
      if (this.paramDetailProcess.numcom !== '' && this.paramDetailProcess.codopert === '') {
        if (this.eventBtn === 'add') {
          let detailParams = {
            numcom: this.detailPopupProcess.numcom
          }
          this.receivedHres3cuDetailProcessPopup(detailParams)
        }
      }
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        searchIndex: this.searchIndex,
        indexSelected: this.indexSelected,
        paramDetailProcess: this.paramDetailProcess,
        referenceButton: this.$refs.detailPopupProcessModalButton
      }
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHres3cuDetailprocessPopup(_this.saveParams())
        }
      })
    },
    closeModal () {
      this.$refs.detailPopupProcessModalButton.click()
    }
  },
  props: [ 'labels',
    'nowLang',
    'postHres3cuDetailprocessPopup',
    'receivedHres3cuDetailProcessPopup',
    'indexSelected',
    'setDetailProcessSelected',
    'labelsButton',
    'searchIndex',
    'detailPopupProcess',
    'validateStaappr'
  ]
}
</script>


// WEBPACK FOOTER //
// popupProcess.vue?5d86afbc